export var PAGINATION_VIEW = {
  LIST: 'list',
  CARD: 'card',
  TABLE: 'table'
};

export var PAGINATION_VIEW_TYPES = [PAGINATION_VIEW.LIST, PAGINATION_VIEW.CARD, PAGINATION_VIEW.TABLE];


//////////////////
// WEBPACK FOOTER
// ./node_modules/patternfly-react/dist/esm/components/Pagination/PaginationConstants.js
// module id = 151
// module chunks = 0